import { Component, Input, OnInit } from '@angular/core';
import { switchMap } from 'rxjs/operators';
import { PrifactRoute } from 'src/app/models/prifact-route';
import { FileDownloadService } from 'src/app/services/file-download-service/file-download.service';
import { RoutingService } from 'src/app/services/routing-service/routing.service';
import { Homework } from '../../models/homework';
import { HomeworksService } from '../../services/homeworks.service';
declare const urlize: any;

@Component({
  selector: 'app-homework-description-attachment',
  templateUrl: './homework-description-attachment.component.html',
  styleUrls: ['./homework-description-attachment.component.scss']
})
export class HomeworkDescriptionAttachmentComponent implements OnInit {

  constructor(private fileDownloadService: FileDownloadService
    , private homeworksService: HomeworksService
    , private routingService: RoutingService) { }

  @Input() homework: Homework;

  ngOnInit() {
    if (this.homework) {
      if (!this.homework.parsed) {
        this.homework.homework_description = this.processLinks(this.homework.homework_description);
        this.homework.parsed = true;
      }
    }
  }

  attachmentClicked(homeworkId: number, homeworkDocId: number) {
    this.homeworksService.getPresignedUrl(homeworkId, homeworkDocId)
      .pipe(
        switchMap(res => {
          return this.fileDownloadService.downloadAndOpen(res.url, res.file_name, res.content_type, true);
        })
      ).subscribe()
  }

  processLinks(text) {
    return urlize(text, { nofollow: true, autoescape: true, target: '_blank' })
  }


  redirectToSubmitPage(homework: Homework) {
    let route = new PrifactRoute();
    route.primary_command = ['pages', 'submit-homework', homework.home_work_id];
    route.append_current_url_to_history = true;
    this.routingService.navigate(route);
  }

}
